import { BaseAPI } from '@services/api';

class API extends BaseAPI {
  constructor() {
    super('nnc/functional-area');
  }
}

export default new API();
